import React, { Component } from 'react'
import { getCustomerBillings } from '../../lib'
import { FormattedMessage, injectIntl } from 'react-intl'
import { Link } from 'react-router-dom'
import CurrencyFormat from 'react-currency-format';
import './Table.css'
const moment = require('moment');

class Billings extends Component {
  constructor(props) {
    super(props)
    this.state = {
      invoices: []
    }
  }

  async componentDidMount() {
    const res = await getCustomerBillings();
    if (res.status && res.status === 'success') {
      this.setState({
        invoices: res.data.invoices
      })
    }
  }

  render() {
    const { intl } = this.props;
    return (
      <table className="custom-table">
        <thead>
          <tr>
            <th scope="col"><FormattedMessage id="billings.type" /></th>
            <th scope="col"><FormattedMessage id="billings.date" /></th>
            <th scope="col"><FormattedMessage id="billings.description" /></th>
            <th scope="col"><FormattedMessage id="billings.amount" /></th>
            <th scope="col"><FormattedMessage id="billings.downloadInvoice" /></th>
          </tr>
        </thead>
        <tbody>
        {this.state.invoices.map((val, index) => (
          val.lines.data.map((line_item, index) => (
            <tr>
              <td data-label={intl.formatMessage({ id: "billings.type"})}>{val.object}</td>
              <td data-label={intl.formatMessage({ id: "billings.date"})}>{moment.unix(val.created).format("MM/DD/YYYY")}</td>
              <td data-label={intl.formatMessage({ id: "billings.description"})}>{line_item.description}</td>
              <td data-label={intl.formatMessage({ id: "billings.amount"})}><CurrencyFormat value={line_item.amount} displayType={'text'} thousandSeparator={true} prefix={'￥'} /></td>
              <td data-label={intl.formatMessage({ id: "billings.downloadInvoice"})} className="invoice-link">
                { val.invoice_pdf ?
                  <div>
                    <Link
                      to={val.invoice_pdf}
                      target="_blank">
                        <FormattedMessage id="billings.downloadInvoice" />
                    </Link>
                    <br />
                    <Link
                      to={val.receipt_url}
                      target="_blank">
                        <FormattedMessage id="billings.downloadReceipt" />
                    </Link>
                  </div>
                :
                  '-'}
              </td>
            </tr>
          ))
        ))}
      </tbody>
    </table>
    )
  }
}

export default injectIntl(Billings)



// WEBPACK FOOTER //
// src/routes/Billings/Billings.js